import styled from 'styled-components';

export const SVGContainer = styled.svg`
    overflow: visible;
    pointer-events: none;
    position: absolute;
    top: 0;
    z-index: 100;
`;
